import React, { useState } from 'react';
import Loading from 'swag-client-common/components/info/loading';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import sendosoClasses from 'swag-client-common/components/popups/login-popup/login-popup-other.sendoso.scss';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes.sendoso';
const LoginPopup = ({
  isOpen,
  isSuspenseFallback,
  isLoggedOut,
  error
}) => {
  const [isLoading, setIsLoading] = useState(false);
  if (isSuspenseFallback || isLoggedOut) {
    return null;
  }
  const onSignInClick = () => {
    setIsLoading(true);
    location.replace(APP_ROUTES.API_AUTH_REDIRECT);
  };
  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: utilClasses.textCenter
    }, /*#__PURE__*/React.createElement("h2", null, "Welcome to Custom Brand Shop!"), /*#__PURE__*/React.createElement("div", null, "In order to proceed please log in using your Sendoso login and password."), error && /*#__PURE__*/React.createElement("div", {
      className: sendosoClasses.loginError
    }, error), !isLoading && /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      size: "small",
      className: sendosoClasses.submitButton,
      dataButton: "Login",
      onClick: onSignInClick
    }, "Sign in"), isLoading && /*#__PURE__*/React.createElement("div", {
      className: sendosoClasses.loaderHolder
    }, /*#__PURE__*/React.createElement(Loading, null)));
  };
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: isOpen,
    showCloseButton: false,
    content: renderContent(),
    bodyClassName: sendosoClasses.loginTenantBody,
    dataPopup: "SendosoWelcome"
  });
};
export { LoginPopup };